import React from 'react';

import { Link } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps, withTypography } from 'components/ui';
import { layout, primitive, spacing } from 'styles/constants';

import theme from '../theme';

export const ImageContainer = ({ children, style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.imageContainer, style] }, children);

export const Image = Picture.withConfig({
  width: '5/6',
  borderRadius: primitive.$borderRadius,
});

export const ImageCaption = withTypography({
  pt: '$4',
  textAlign: theme.imageWidgetCaptionAlign as any,
});

export const ImageCaptionLink = Link.withConfig({
  color: primitive.$fieryRed,
  marginRight: '$2',
  fontSize: 'sm',
});

const styles = StyleSheet.create({
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: spacing.$6,
    width: layout.full,
  },
});
